import type { NormalizedField } from "../form/runtimeModel";

export function isMaintenanceCompleted(asset: Record<string, unknown> | null | undefined): boolean {
  if (!asset) return false;
  const explicit = asset.current_maintenance_completed;
  if (explicit === true) return true;
  const eventId = Number(asset.current_maintenance_event_id ?? asset.maintenance_event_id);
  const hasEvent = Number.isFinite(eventId) && eventId > 0;
  const resultStatus = String(asset.current_maintenance_result_status ?? asset.result_status ?? "")
    .trim()
    .toLowerCase();
  return hasEvent && resultStatus !== "" && resultStatus !== "open";
}

export function maintenanceEventId(asset: Record<string, unknown> | null | undefined): number | null {
  if (!asset) return null;
  const id = Number(asset.current_maintenance_event_id ?? asset.maintenance_event_id);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function canEditCompletedMaintenance(
  asset: Record<string, unknown> | null | undefined,
  projectCompleted: boolean | null | undefined,
): boolean {
  return isMaintenanceCompleted(asset) && projectCompleted !== true;
}

export function stripSignatureValues(
  fields: NormalizedField[],
  values: Record<string, unknown>,
): Record<string, unknown> {
  const signatureKeys = new Set(
    fields.filter((field) => field.effective_field_type === "signature").map((field) => field.field_key),
  );
  if (!signatureKeys.size) return values;
  const next = { ...values };
  for (const key of signatureKeys) {
    delete next[key];
  }
  return next;
}

export function stripSignatureScopedValues(
  fields: NormalizedField[],
  values: { masterdata: Record<string, unknown>; inspection: Record<string, unknown> },
): { masterdata: Record<string, unknown>; inspection: Record<string, unknown> } {
  const masterKeys = new Set(
    fields
      .filter((field) => field.effective_field_type === "signature" && field.effective_scope === "masterdata")
      .map((field) => field.field_key),
  );
  const inspectionKeys = new Set(
    fields
      .filter((field) => field.effective_field_type === "signature" && field.effective_scope === "inspection")
      .map((field) => field.field_key),
  );
  const masterdata = { ...values.masterdata };
  const inspection = { ...values.inspection };
  for (const key of masterKeys) delete masterdata[key];
  for (const key of inspectionKeys) delete inspection[key];
  return { masterdata, inspection };
}

export function maintenanceStartButtonLabel(
  asset: Record<string, unknown> | null | undefined,
  projectCompleted: boolean | null | undefined,
): string {
  if (canEditCompletedMaintenance(asset, projectCompleted)) return "Wartung bearbeiten";
  if (isMaintenanceCompleted(asset)) return "Wartung abgeschlossen";
  const hasFormData = asset?.current_maintenance_has_form_data === true;
  const started = asset?.current_maintenance_started === true;
  if (started || hasFormData) return "Wartung fortsetzen";
  return "Wartung durchführen";
}
